/* Header: accessible dropdown / mega-menu, header height variable, scroll-up sticky behaviour. */
(() => {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const wrapper = header.closest('.shopify-section');
  const items = [...header.querySelectorAll('[data-nav-item]')];
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  let closeTimer;

  const setOpen = (item, open) => {
    const toggle = item.querySelector('[data-nav-toggle]');
    const panel = item.querySelector('[data-nav-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    item.classList.toggle('is-open', open);
  };
  const closeAll = (except) => items.forEach((item) => item !== except && setOpen(item, false));

  items.forEach((item) => {
    const toggle = item.querySelector('[data-nav-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      closeAll(item);
      setOpen(item, open);
    });

    item.addEventListener('mouseenter', () => {
      if (!canHover.matches) return;
      clearTimeout(closeTimer);
      closeAll(item);
      setOpen(item, true);
    });
    item.addEventListener('mouseleave', () => {
      if (!canHover.matches) return;
      closeTimer = setTimeout(() => setOpen(item, false), 150);
    });
    // Leaving the item with the keyboard closes its panel.
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setOpen(item, false);
    });
  });

  // Escape closes any open panel and returns focus to its toggle.
  header.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = items.find((item) => item.classList.contains('is-open'));
    if (!open) return;
    setOpen(open, false);
    open.querySelector('[data-nav-toggle]')?.focus();
  });
  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) closeAll();
  });

  // Expose header height for scroll padding and sticky offsets.
  const setHeight = () => document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  setHeight();
  if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(header);

  // Hide on scroll down, reveal on scroll up.
  if (document.documentElement.dataset.headerSticky === 'scroll-up' && wrapper) {
    let lastY = window.scrollY;
    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const y = window.scrollY;
          const goingDown = y > lastY && y > header.offsetHeight * 2;
          const menuOpen = items.some((item) => item.classList.contains('is-open')) || header.contains(document.activeElement);
          wrapper.classList.toggle('is-hidden', goingDown && !menuOpen);
          lastY = y;
          ticking = false;
        });
      },
      { passive: true }
    );
  }
})();
